import { withMondayCache } from "frontend/services/monday/monday-cache";
import { getBoardsWithWorkspaceQuery } from "shared/api/monday";
import { MondayWorkspace, MondayWorkspacesWithCursor } from "shared/datamodel/schemas/monday-workspace";
import mondaySdk from "monday-sdk-js";
import { getWorkspacesForUser } from "shared/api/monday/workspaces";

const monday = mondaySdk();

const LIMIT = 200;

export const getWorkspacesForUserUsingSDK = async ({ page }: { page: number }) => {
  try {
    const fetchPage = async (page: number): Promise<MondayWorkspace[]> => {
      const query = getBoardsWithWorkspaceQuery({ page, limit: LIMIT });

      try {
        const response = await monday.api<{ boards: { workspace: MondayWorkspace }[] }>(query);
        return response.data.boards.map((board) => board.workspace);
      } catch (error) {
        console.error("Error fetching workspaces:", error);
        return [];
      }
    };

    return withMondayCache<MondayWorkspacesWithCursor>(`monday-workspaces-${page}-${LIMIT}`, "DAY", () =>
      getWorkspacesForUser({
        fetcher: fetchPage,
        page,
        limit: LIMIT,
        logger: console,
      })
    );
  } catch (error) {
    console.error("error while calculating workspaces", { error });
    return {
      workspaces: [],
      cursor: page,
    };
  }
};
